import $ from 'jquery';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {BrowserRouter as BrowserRouter, Route, Switch} from 'react-router-dom';
import AuthComponent from './baseContainers/AuthComponent';
import CookieConsent from './components/CookieConsent';
import Sidebar from './components/layouts/Sidebar';
import ChangePasswordContainer from './containers/ChangePasswordContainer';
import RemindPasswordContainer from './containers/RemindPasswordContainer';
import CookiesContainer from './containers/CookiesContainer';
import EventLogListContainer from './containers/EventLogListContainer';
import EmailListContainer from './containers/email/EmailListContainer';
import IssueListContainer from './containers/issue/IssueListContainer';
import Login from './containers/LoginContainer';
import SettingListContainer from './containers/SettingListContainer';
import AuthService from './services/AuthService';
import AccountService from './services/AccountService';
import EmailContainer from './containers/email/EmailContainer';
import ConfirmPasswordContainer from './containers/user/ConfirmPasswordContainer';
import MobileUserListContainer from './containers/user/MobileUserListContainer';
import TokenAuthPage from './containers/TokenAuthPage';
import AvatarListContainer from './containers/avatar/AvatarListContainer';
import GroupsListContainer from './containers/GroupsListContainer';
import QuizListContainer from './containers/quiz/QuizListContainer';
import WelcomeSurveyListContainer from './containers/quiz/WelcomeSurveyListContainer';
import QuizContainer from './containers/quiz/QuizContainer';
import QRCodeListContainer from './containers/qrcode/QRCodeListContainer';
import QRCodeContainer from './containers/qrcode/QRCodeContainer';
import SettingService from './services/SettingService';
import UserListContainer from './containers/user/UserListContainer';
import WelcomeSurveyContainery from './containers/quiz/WelcomeSurveyContainery';
import i18n from './i18n';
import PartnerContainer from './containers/partner/PartnerContainer';
import PartnerListContainer from './containers/partner/PartnerListContainer';
import VoucherCategoryListContainer from './containers/marketplace/category/VoucherCategoryListContainer';
import VoucherListContainer from './containers/marketplace/voucher/VoucherListContainer';
import VoucherCategoryContainer from './containers/marketplace/category/VoucherCategoryContainer';
import VoucherContainer from './containers/marketplace/voucher/VoucherContainer';
import GroupDetailContainer from './containers/GroupDetailContainer';
import NewsListContainer from './containers/news/NewsListContainer';
import NewsContainer from './containers/news/NewsContainer';
import ActionListContainer from './containers/action/ActionListContainer';
import ActionContainer from './containers/action/ActionContainer';
import TransportListContainer from './containers/transport/TransportListContainer';
import TransportContainer from './containers/transport/TransportContainer';
import ChallengeContainer from './containers/challenge/ChallengeContainer';
import ChallengeListContainer from './containers/challenge/ChallengeListContainer';
import PushMessagesListContainer from './containers/pushMsg/PushMessagesListContainer';
import PushMessagesContainer from './containers/pushMsg/PushMessagesContainer';
import ProfileContainer from './containers/user/account/ProfileContainer';
import VersionContainer from './containers/VersionContainer';
import UserTransportListContainer from './containers/transport/UserTransportListContainer';
import UserTransportContainer from './containers/transport/UserTransportContainer';
import LanguageContext from './context/LanguageContext';
import LogoutContext from './context/LogoutContext';
import UserSummaryListContainer from './containers/summary/UserSummaryListContainer';
import CompanyContainer from './containers/company/CompanyContainer';
import history from './utils/customHistory';
import UserPayrollListContainer from './containers/payroll/UserPayrollListContainer';
import UserPayrollContainer from './containers/payroll/UserPayrollContainer';
import LogEntryListContainer from './containers/log/LogEntryListContainer';
import UpdateAppDialog from './containers/UpdateAppDialog';
import DashboardContainer from './containers/dashboard/DashboardContainer';
import RankListContainer from './containers/rank/RankListContainer';
import RankingContainer from './containers/ranking/RankingContainer';
import MobileUserDetailsContainer from './containers/user/MobileUserDetailsContainer.js';
import UserActionListContainer from './containers/action/UserActionListContainer.js';
import EventContainer from './containers/event/EventContainer.js';
import store from './store.js';
import CompanyTransportListContainer from './containers/transport/CompanyTransportListContainer.js';
import CompanyTransportContainer from './containers/transport/CompanyTransportContainer.js';
import UserVoucherListContainer from './containers/marketplace/userVoucher/UserVoucherListContainer.js';

class App extends Component {
    constructor() {
        super();
        this.authService = new AuthService();
        this.userService = new AccountService();
        this.settingService = new SettingService();
        this.state = {
            appInfo: {
                version: process.env.REACT_APP_VERSION,
                buildNumber: process.env.REACT_APP_BUILD_NUMBER,
                lastVersionReleaseNote: process.env.REACT_APP_LAST_VERSION_RELEASE_NOTE,
            },
            user: this.authService.getProfile(),
            collapsed: false,
            toggled: false,
            renderSidebar: true,
            updateAppDialogVisible: false,
        };
        this.handleLogoutUser = this.handleLogoutUser.bind(this);
        this.handleHideMenu = this.handleHideMenu.bind(this);
        this.handleShowMenu = this.handleShowMenu.bind(this);
        this.setActiveMenu = this.setActiveMenu.bind(this);
        this.handlePreLogoutUser = this.handlePreLogoutUser.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
    }
    setActiveMenu(activeUrl) {
        if (activeUrl !== this.state.activeUrl) {
            this.setState({activeUrl});
        }
    }
    handleHideMenu() {
        if (!!this.state.renderSidebar) {
            this.setState({renderSidebar: false});
        }
    }

    handleShowMenu() {
        if (!this.state.renderSidebar) {
            this.setState({renderSidebar: true});
        }
    }
    handleToggleSidebar() {
        this.setState((prevState) => ({toggled: !prevState.toggled}));
    }

    handleCollapsedChange() {
        this.setState(
            (prevState) => ({collapsed: !prevState.collapsed}),
            () => {
                if (this.state.collapsed) {
                    $('.pro-sidebar-inner').css('position', 'relative');
                } else {
                    $('.pro-sidebar-inner').css('position', 'fixed');
                }
            }
        );
    }

    handleLogoutUser = (url) => {
        const lastUseToken = this.authService.getToken();
        this.authService.logout();
        if (!!url && typeof url === 'string') {
            window.location.href = '/login?location=' + url;
        } else {
            window.location.href = '/login?force=true';
        }
        if (this.state.user) {
            this.setState({user: null});
        }
        if (lastUseToken !== undefined && lastUseToken !== null) {
            this.userService.logout(lastUseToken);
        }
    };
    afterPreLogoutUser() {}

    handlePreLogoutUser(callBack) {
        this.authService.logout();
        if (this.state.user !== null) {
            this.setState({user: null}, () => this.afterPreLogoutUser());
            this.setState({user: null}, () => {
                if (callBack) callBack();
            });
        } else {
            if (callBack) callBack();
        }
    }
    updateApp(oldVersion, newVersion) {
        if (this.state.updateAppDialogVisible !== true) {
            this.setState({updateAppDialogVisible: true, appOldVersion: oldVersion, appNewVersion: newVersion});
        }
    }
    componentDidUpdate(){
        if(this.authService.loggedIn()){
            const currentUser =  this.authService.getProfile();
            store.getState().setCompanyLocale(currentUser.locale);
        }
    }
    componentDidMount() {
        if (this.authService.loggedIn()) {
            const currentUser =  this.authService.getProfile();
            store.getState().setCompanyLocale(currentUser.locale);
            this.settingService
                .getSupportedLocales()
                .then((res) => {
                    store.getState().setSupportedLocales(res)
                    localStorage.setItem('supportedLanguages', res);
                })
                .catch(() => {
                    console.log('cannot fetch locales');
                });
        }
    }
    changeLanguage = (locale) => {
        i18n.changeLanguage(locale);
        this.setState({lng: !this.state.lng});
    };
    render() {
        const authService = this.authService;
        return (
            <React.Fragment>
                <UpdateAppDialog
                    visible={this.state.updateAppDialogVisible}
                    handleClose={() => {
                        this.setState({updateAppDialogVisible: false});
                    }}
                    oldVersion={this.state.appOldVersion}
                    newVersion={this.state.appNewVersion}
                />
                <CookieConsent
                    location='bottom'
                    buttonText='Akceptuję'
                    cookieName='cookiePolicy'
                    style={{background: 'rgba(0, 0, 0, 0.8)'}}
                    buttonStyle={{
                        background: '#1c3275',
                        color: 'white',
                        fontSize: '16px',
                        fontFamily: 'Ubuntu',
                        fontWeight: 500,
                        borderRadius: '3px',
                    }}
                    expires={150}
                >
                    Nasz serwis wykorzystuje pliki cookies. Możesz zrezygnować ze zbierania informacji poprzez pliki cookies, zmieniając
                    ustawienia Twojej przeglądarki - w takim przypadku nie gwarantujemy poprawnego działania serwisu.
                </CookieConsent>
                <BrowserRouter history={history}>
                    <LogoutContext.Provider value={this.handleLogoutUser}>
                        <LanguageContext.Provider value={this.changeLanguage}>
                            <div className={`app ${!this.authService.loggedIn() ? 'root-child-when-footer' : ''}`}>
                                {!authService.loggedOut() && this.state.renderSidebar ? (
                                    <div>
                                        <div className='sidebar-vertical'>
                                            <Sidebar
                                                key={Date.now()}
                                                collapsed={this.state.collapsed}
                                                toggled={this.state.toggled}
                                                loggedUser={this.state.user}
                                                handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                                handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                                handleLogoutUser={this.handleLogoutUser.bind(this)}
                                                authService={this.authService}
                                                submenu={undefined}
                                                activeUrl={this.state.activeUrl}
                                            />
                                        </div>
                                        <div className='sidebar-horizontal'>
                                            <Sidebar
                                                key={Date.now()}
                                                collapsed={this.state.collapsed}
                                                toggled={this.state.toggled}
                                                loggedUser={this.state.user}
                                                handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                                handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                                handleLogoutUser={this.handleLogoutUser.bind(this)}
                                                authService={this.authService}
                                                userService={this.userService}
                                                submenu={true}
                                                activeUrl={this.state.activeUrl}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                <main>
                                    <Switch>
                                        <Route
                                            exact
                                            path='/forgot-password'
                                            component={(prp) => (
                                                <RemindPasswordContainer
                                                    {...prp}
                                                    onAfterLogin={() => {
                                                        this.setState({
                                                            user: this.authService.getProfile().sub,
                                                        });
                                                    }}
                                                    type='REMIND'
                                                />
                                            )}
                                        />
                                        <Route exact path='/start' component={(prp) => <AuthComponent {...prp} user={this.state.user} />} />
                                        <Route
                                            exact
                                            path='/'
                                            component={(prp) => (
                                                <Login
                                                    {...prp}
                                                    onAfterLogin={() => {
                                                        this.setState({
                                                            user: this.authService.getProfile().sub,
                                                        });
                                                    }}
                                                />
                                            )}
                                        />
                                        <Route
                                            path='/activate-email'
                                            component={(props) => (
                                                <TokenAuthPage
                                                    {...props}
                                                    type='CREATE'
                                                    handlePreLogoutUser={this.handlePreLogoutUser.bind(this)}
                                                />
                                            )}
                                        />
                                        <Route
                                            path='/login'
                                            component={(prp) => (
                                                <Login
                                                    {...prp}
                                                    onAfterLogin={() => {
                                                        this.setState({
                                                            user: this.authService.getProfile().sub,
                                                        });
                                                    }}
                                                />
                                            )}
                                        />
                                        <Route exact path='/cookies-page' component={(prp) => <CookiesContainer {...prp} />} />
                                        <Route
                                            exact
                                            path='/event-log-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <EventLogListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/manage-account/details'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ProfileContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                userId={this.authService.getProfile().userId}
                                                                userEmail={this.authService.getProfile().sub}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/dashboard'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <DashboardContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                userId={this.authService.getProfile().userId}
                                                                userEmail={this.authService.getProfile().sub}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/ranking'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <RankingContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                userId={this.authService.getProfile().userId}
                                                                userEmail={this.authService.getProfile().sub}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/manage-account/edit/:id'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ProfileContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                userId={this.authService.getProfile().userId}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/email-template-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <EmailListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/issue-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_SUPER_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <IssueListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/avatar-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <AvatarListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/welcome-survey/details/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <WelcomeSurveyContainery
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/welcome-survey/edit/:id/:lang'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <WelcomeSurveyContainery
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/welcome-survey/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <WelcomeSurveyContainery
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/welcome-survey-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <WelcomeSurveyListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher-category-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherCategoryListContainer
                                                                key={Date.now()}
                                                                renderChangeLanguegeFilter={true}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher-category/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherCategoryContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher-category/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherCategoryContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher-category/edit/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherCategoryContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/transport-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <TransportListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/company-transport-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyTransportListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                           <Route
                                            exact
                                            path='/company-transport/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyTransportContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/company-transport/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyTransportContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/company-transport/edit/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyTransportContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/user-transport-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR', 'ROLE_VIEW_ROUTES']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserTransportListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/user-summary-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR', 'ROLE_VIEW_ROUTES']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserSummaryListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/user-payroll-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserPayrollListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-payroll/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserPayrollContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />{' '}
                                        <Route
                                            exact
                                            path='/user-transport/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserTransportContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-transport/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserTransportContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-transport/edit/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserTransportContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/transport/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <TransportContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/transport/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <TransportContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/transport/edit/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <TransportContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/company/details'
                                            render={(prp) => {
                                                //const CompanyDetailsGuard = require('./containers/company/CompanyDetailsGuard').default;
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/company/edit'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanyContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/company/setup'
                                            render={(prp) => {
                                                const CompanySetupWizardContainer = require('./containers/company/CompanySetupWizardContainer').default;
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <CompanySetupWizardContainer
                                                                key={Date.now()}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                         <Route
                                            exact
                                            path='/voucher-purchased-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserVoucherListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/voucher/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <VoucherContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/partner-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PartnerListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/partner/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PartnerContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/partner/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PartnerContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/partner/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PartnerContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/qrcode-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QRCodeListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                locale={prp.match.params.locale}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/qrcode/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QRCodeContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/qrcode/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QRCodeContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/qrcode/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QRCodeContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/email-template/details/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <EmailContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                lang={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />{' '}
                                        <Route
                                            exact
                                            path='/email-template/edit/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <EmailContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                lang={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/avatar-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <AvatarListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                lang={prp.match.params.lang}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/setting-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <SettingListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                lang={prp.match.params.lang}
                                                                renderChangeLanguegeFilter={true}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/users-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                lang={prp.match.params.lang}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-ranks-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <RankListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                lang={prp.match.params.lang}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/logentry-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <LogEntryListContainer
                                                                objectType={undefined}
                                                                objectId={this.props.elementId}
                                                                expandFilters={false}
                                                                renderHeader={false}
                                                                filterOptions={true}
                                                                filteredOptionsList={undefined}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-register'
                                            key={Date.now()}
                                            component={(prp) => (
                                                <ConfirmPasswordContainer
                                                    {...prp}
                                                    lang={'pl'}
                                                    user={this.state.user}
                                                    onAfterLogin={(callBack) => {
                                                        this.setState(
                                                            {
                                                                user: this.authService.getProfile().sub,
                                                            },
                                                            () => {
                                                                callBack();
                                                            }
                                                        );
                                                    }}
                                                    handlePreLogoutUser={this.handlePreLogoutUser}
                                                    type='CREATE'
                                                />
                                            )}
                                        />
                                        <Route
                                            exact
                                            path='/set-password/:token'
                                            key={Date.now()}
                                            component={(prp) => (
                                                <ChangePasswordContainer
                                                    {...prp}
                                                    lang={'pl'}
                                                    onAfterLogin={() => {
                                                        this.setState({
                                                            user: this.authService.getProfile().sub,
                                                        });
                                                    }}
                                                />
                                            )}
                                        />
                                        <Route
                                            exact
                                            path='/mobile-user-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <MobileUserListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/mobile-user/details/:id/:invitationId?'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <MobileUserDetailsContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                elementId={prp.match.params.id}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                                invitation={prp.match.params.invitationId}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/mobile-user/edit/:id'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <MobileUserDetailsContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                elementId={prp.match.params.id}
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/mobile-user/new/'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <MobileUserDetailsContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/event-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <EventContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/quiz-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QuizListContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/quiz/create/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QuizContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/quiz/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QuizContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/quiz/details/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <QuizContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/action/details/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ActionContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/action/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ActionContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/action-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ActionListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/user-action-list/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <UserActionListContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/action/create/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ActionContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            key={Date.now()}
                                            exact
                                            path='/challenge/details/:id/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                                type='CHALLENGE'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/challenge/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                                type='CHALLENGE'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/challenge-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                                type='CHALLENGE'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={Date.now()}
                                            path='/challenge/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                                type='CHALLENGE'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/groups-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        key={Date.now()}
                                                        component={
                                                            <GroupsListContainer
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/groups/edit/:id'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <GroupDetailContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/groups/details/:id'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <GroupDetailContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/groups/create'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <GroupDetailContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/news-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <NewsListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/news/create/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <NewsContainer
                                                                key={Date.now()}
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/news/edit/:id/:lang'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <NewsContainer
                                                                key={Date.now()}
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.lang}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/news/details/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <NewsContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/achievements/details/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                                type='ACHIEVEMENT'
                                                                editUrl='/achievements/edit'
                                                                backUrl='/achievements-list'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/achievements/edit/:id/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                                type='ACHIEVEMENT'
                                                                editUrl='/achievements/edit'
                                                                backUrl='/achievements-list'
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/achievements-list'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeListContainer
                                                                key={Date.now()}
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                type='ACHIEVEMENT'
                                                                detailUrl='/achievements/details'
                                                                newUrl='/achievements/create'
                                                                editUrl='/achievements/edit'
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/achievements/create/:locale'
                                            key={Date.now()}
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <ChallengeContainer
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                type='ACHIEVEMENT'
                                                                editUrl='/achievements/edit'
                                                                backUrl='/achievements-list'
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/pushMsg-list'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PushMessagesListContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/pushMsg/create/:locale'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PushMessagesContainer
                                                                viewMode='NEW'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.locale}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/pushMsg/edit/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PushMessagesContainer
                                                                viewMode='EDIT'
                                                                currentUser={this.state.user}
                                                                locale={prp.match.params.lang}
                                                                elementId={prp.match.params.id}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route
                                            exact
                                            path='/pushMsg/details/:id/:lang'
                                            render={(prp) => {
                                                return (
                                                    <AuthComponent
                                                        {...prp}
                                                        roles={['ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR']}
                                                        user={this.state.user}
                                                        component={
                                                            <PushMessagesContainer
                                                                viewMode='VIEW'
                                                                currentUser={this.state.user}
                                                                elementId={prp.match.params.id}
                                                                locale={prp.match.params.lang}
                                                                updateApp={this.updateApp}
                                                            />
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                        <Route path='/version' render={(props) => <VersionContainer />} />
                                    </Switch>
                                </main>
                            </div>
                        </LanguageContext.Provider>
                    </LogoutContext.Provider>
                </BrowserRouter>
            </React.Fragment>
        );
    }
}

export default withTranslation()(App);
